<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ul *ngIf="items && items.length > 0" class="navbar-list navbar-nav nav-collapsed-items">

    <li class="top-nav nav-item dropdown non-grouped">

        <a class="nav-link-nongrouped dropdown-toggle" *ngIf="hoverEnabled()"
           [class]="{
               'hover-enabled': true,
               'nav-link-activated': showDropdown()
           }"
           (click)="toggleDropdown()">
            <scrm-label [labelKey]="labelKey"></scrm-label>
        </a>

        <a class="nav-link-nongrouped dropdown-toggle" *ngIf="!hoverEnabled()"
           [class]="{
               'hover-enabled':false,
               'nav-link-activated': showDropdown()
           }"
           (click)="toggleDropdown()">
            <scrm-label [labelKey]="labelKey"></scrm-label>
        </a>

        <div aria-labelledby="navbarDropdownMenuLink"
             (click)="hideDropdown()"
             class="dropdown-menu more-menu submenu"
             [class.show]="showDropdown()"
             [class.hover-enabled]="hoverEnabled()"
        >
            <div *ngFor="let item of items" class="nav-item">
                <scrm-menu-item-link [class]="'nav-link action-link'" [link]="item.link">
                </scrm-menu-item-link>
            </div>
        </div>
    </li>
</ul>

